import { Stack, StackProps } from '@mui/material';

export function CommandPaletteBody({ sx, children, ...restProps }: StackProps) {
  const defaultSx = {
    overflow: 'auto',
    p: 3,
    pt: 2,
    ...sx,
  };

  return (
    <Stack sx={defaultSx} {...restProps}>
      {children}
    </Stack>
  );
}

export default CommandPaletteBody;
